import { SnackbarToaster } from "@pocketsign/design-system";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import * as React from "react";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "../components/error-boundary";
import { STORE_CONSOLE_SNACKBAR_TOASTER_ID } from "../libs/store-console-snackbar";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <React.Fragment>
        <Outlet />
        <Toaster />
        <SnackbarToaster toasterId={STORE_CONSOLE_SNACKBAR_TOASTER_ID} />
      </React.Fragment>
    </ErrorBoundary>
  );
}
